import React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

const LinearLoader = () => (
  <>
    <div>
      <Box sx={{ width: '20rem', marginTop: '3rem' }}>
        <LinearProgress />
      </Box>
    </div>
  </>
);

export default LinearLoader;
